import { render, staticRenderFns } from "./starter.vue?vue&type=template&id=34062182&scoped=true&"
import script from "./starter.vue?vue&type=script&lang=js&"
export * from "./starter.vue?vue&type=script&lang=js&"
import style0 from "./starter.vue?vue&type=style&index=0&id=34062182&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34062182",
  null
  
)

export default component.exports